// @file Composable to check for unsaved comment drafts and prevent page reload
import { useCommentsStore } from '@@/pinia/surface_comments'
import { useCheckUnsavedChangesBeforeReload } from '@@/vuecomposables/useCheckUnsavedChangesBeforeReload'

export const useCommentDraftUnsavedChanges = (): void => {
  const commentsStore = useCommentsStore()

  useCheckUnsavedChangesBeforeReload({
    shouldAlert: () => {
      return commentsStore.shouldShowUnsavedChangesDialog
    },
  })
}
